import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BaseComponent } from '../../shared/common/base.component';
import { DateService } from '../../shared/services/date.service';
import { TitleService } from '../../shared/services/title.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseComponent implements OnInit, OnDestroy {
  public currentDate: Date;
  public pageTitle: string;
  public version: string;

  private updateDateTimer: any;

  constructor(private readonly titleService: TitleService, private readonly dateService: DateService) {
    super();
    this.currentDate = this.dateService.getCurrent();
  }

  public async ngOnInit(): Promise<void> {
    this.titleService
      .getTitle()
      .pipe(takeUntil(this.destroy$))
      .subscribe((title: string) => {
        this.pageTitle = title;
      });

    this.updateDateTimer = setInterval(() => {
      this.currentDate = this.dateService.getCurrent();
    }, 1000);
    this.version = `FRONT : ${environment.version} BACK : ${environment.api.version}`;
  }

  public ngOnDestroy(): void {
    if (this.updateDateTimer) {
      clearInterval(this.updateDateTimer);
    }
    super.ngOnDestroy();
  }
}
